module.exports = __webpack_public_path__ + "img/logo-bbva.c458bf89.png";